import React from "react";

import { connect } from "react-redux";

import Loader from "../components/Loader";

import Login from "./Login";
import TypeOfHome from "./TypeOfHome";
import ConsoleBrok from "./ConsoleBrok";
import LoanSummary from "./LoanSummary";
import BorrowerInfo from "./BorrowerInfo";
import { PAGES } from "../config/constants";
import BorrowerInfo2 from "./BorrowerInfo2";
import ResetPassword from "./ResetPassword";
import BrokerQuestion from "./BrokerQuestion";
import BorrowerCredit from "./BorrowerCredit";
import SubmittingLoan from "./SubmittingLoan";
import PasswordScreen from "./PasswordScreen";
import PropertyAddress from "./PropertyAddress";
import EnterCode from "./ResetPassword/EnterCode";
import ConsoleBrok2 from "./ConsoleBrok/ConsoleBrok2";
import ConsoleBrok3 from "./ConsoleBrok/ConsoleBrok3";
import ConsoleBrok4 from "./ConsoleBrok/ConsoleBrok4";

const MainScreen = ({ page, loading }) => {
  return (
    <React.Fragment>
      {page === PAGES.TYPE_OF_LOAN && <TypeOfHome />}
      {page === PAGES.SUBMITTING_LOAN && <SubmittingLoan />}
      {page === PAGES.BORROWER_INFO && <BorrowerInfo />}
      {page === PAGES.PASSWORD_SCREEN && <PasswordScreen />}
      {page === PAGES.BORROWER_CREDIT && <BorrowerCredit />}
      {page === PAGES.PROPERTY_ADDRESS && <PropertyAddress />}
      {page === PAGES.CONSOLE_BROOK_1 && <ConsoleBrok />}
      {page === PAGES.LOAN_SUMMARY && <LoanSummary />}
      {page === PAGES.CONSOLE_BROOK_2 && <ConsoleBrok2 />}
      {page === PAGES.CONSOLE_BROOK_3 && <ConsoleBrok3 />}
      {page === PAGES.CONSOLE_BROOK_4 && <ConsoleBrok4 />}
      {page === PAGES.LOGIN && <Login />}
      {page === PAGES.BROKER_QUESTION && <BrokerQuestion />}
      {page === PAGES.BORROWER_INFO2 && <BorrowerInfo2 />}
      {page === PAGES.RESET_PASS_1 && <ResetPassword />}
      {page === PAGES.RESET_PASS_2 && <EnterCode />}

      <Loader open={loading} />
    </React.Fragment>
  );
};

const mapState = (state) => {
  return {
    page: state.page.page,
    loading: state.loader.loading,
  };
};

export default connect(mapState)(MainScreen);



// WEBPACK FOOTER //
// ./src/Screens/index.js